import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileViewerComponent } from '../repository/file-viewer/file-viewer.component';
import { MaterialModule } from '../core/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportDetailsComponent } from '../repository/report-details/report-details.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from '../shared/shared.module';
import { DownloadAllFilesComponent } from '../repository/report-details/download-all-files/download-all-files.component';
import { RequestFilesComponent } from '../repository/report-details/request-files/request-files.component';
import { ImageViewerModule } from '@hallysonh/ngx-imageviewer';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { CreatToplineComponent } from '../repository/creat-topline/creat-topline.component';
import { ToplineAliasComponent } from '../repository/creat-topline/topline-alias/topline-alias.component';
import { ToplineParametersComponent } from '../repository/creat-topline/topline-parameters/topline-parameters.component';
import { ExpandMode, NgxTreeSelectModule } from 'src/ngx-tree-select/src';
import { MainPipe } from '../shared/pipe/main.pipe.module';
import { MovingToplineComponent } from '../repository/report-details/moving-topline/moving-topline.component';
import { TableDeleteModalComponent } from '../repository/excel-viewer/table-delete-modal/table-delete-modal.component';
import { ViewAiDiscussionGuidComponent } from './view-ai-discussion-guid/view-ai-discussion-guid.component';



@NgModule({
  declarations: [
    FileViewerComponent,
    ReportDetailsComponent,
    DownloadAllFilesComponent,
    RequestFilesComponent,
    CreatToplineComponent,
    ToplineAliasComponent,
    ToplineParametersComponent,
    MovingToplineComponent,
    TableDeleteModalComponent,
    ViewAiDiscussionGuidComponent,
  ],
  entryComponents:[
    TableDeleteModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    InfiniteScrollModule,
    NgxDocViewerModule,
    ImageViewerModule,
    MainPipe,
    NgxTreeSelectModule.forRoot({
      idField: 'id',
      textField: 'name',
      expandMode: ExpandMode.Selection,
    }),
  ],
  exports:[
    FileViewerComponent,
    ReportDetailsComponent,
    RequestFilesComponent,
    DownloadAllFilesComponent,
    CreatToplineComponent,
    ToplineAliasComponent,
    ToplineParametersComponent,
    MovingToplineComponent,
  ]
})
export class SharedRepositoryModule { }
